import { Component, HostListener, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UbicacionesService } from '../../service/ubicaciones.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare let L: any;

@Component({
  selector: 'app-consultorios-psicologicos',
  templateUrl: './consultorios-psicologicos.component.html',
  styleUrls: ['./consultorios-psicologicos.component.css']
})
export class ConsultoriosPsicologicosComponent implements OnInit {
  private subscription = new Subscription();
  infoConsultorio: any = null;
  data: any[] = [];   // JSON que viene de tu servicio
  estados: any[] = [];
  ciudades: any[] = [];

  dataesp: any = {};    // resultado de búsqueda (dirección)
  espec: boolean = false;
  dont: boolean = false;

  map: any;
  marker: any;
  estadoId: any = "";
  ciudadSeleccionada: any = "";

  innerHeight!: number;
  mapLoaded = false;

  markersArray: any[] = [];




  constructor(
    private _ubicacionesService: UbicacionesService,
    private router: Router
  ) {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe();
  }

  ngOnInit(): void {
    this.cargarData();   
  }

  ngAfterViewInit(): void {
    
    setTimeout(() => {
      this.initMap();
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerHeight = window.innerHeight;
  }

  initMap() {

  const container = L.DomUtil.get('Fmap');
  if (container != null) {
    container._leaflet_id = null;
  }

  this.map = L.map('Fmap', {
    center: [19.43, -99.13],
    zoom: 6
  });

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '© OpenStreetMap'
  }).addTo(this.map);

  // 🔽 OCULTAR COVER CUANDO EL MAPA LISTA
  setTimeout(() => {
    const cover = document.querySelector('.map-cover') as HTMLElement;
  }, 500);
}


  cargarData() {
    this._ubicacionesService.getUbicacionesSimiapse().subscribe({
      next: (resp) => {
        // resp es tu array
        console.log("📌 JSON recibido:", resp);
        this.data = resp as any[]; 
        this.obtenerEstados();
      },
      error: (err) => {
        console.error("Error cargando JSON:", err);
      }
    });
  }

  obtenerEstados() {
    const estadosUnicos = [...new Set(this.data.map(item => item.estado))];
    estadosUnicos.sort((a,b)=> a.localeCompare(b));

    this.estados = estadosUnicos.map((nombre, index) => ({
      idestado: index + 1,
      nombre
    }));
  }

  getCiudades(idestado: number) {

    const estadoNombre = this.estados.find(e => e.idestado === idestado)?.nombre;

    const municipiosUnicos = [
      ...new Set(
        this.data
          .filter(item => item.estado === estadoNombre)
          .map(item => item.municipio)
      )
    ];

    municipiosUnicos.sort((a, b) => a.localeCompare(b));

    this.ciudades = municipiosUnicos.map(nombre => ({ nombre }));

    // Limpiar cuadro previo
    this.infoConsultorio = null;
    this.dont = false;
  }

  selectCiudad(ciudad: any) {

  const cover = document.querySelector('.map-cover') as HTMLElement;
  if (cover) cover.classList.add('hidden');

  // 🔍 Obtener TODAS las sucursales del municipio
  const results = this.data.filter(item => item.municipio === ciudad.nombre);

  if (results.length > 0) {

    // Mostrar todas las sucursales en el cuadro
    this.infoConsultorio = results;

    this.dont = false;

    // ❗Eliminar marcador previo si existía
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }

    // ❗Eliminar marcadores anteriores si tienes varios
    if (this.markersArray) {
      this.markersArray.forEach(m => this.map.removeLayer(m));
    }

    this.markersArray = [];

    // Agregar TODOS los marcadores
    results.forEach(result => {

      const lat = Number(result.latitud);
      const lng = Number(result.longitud);

      const simiIcon = L.icon({
        iconUrl: 'assets/images/location_psicho.png',
        iconSize: [50, 50],
        iconAnchor: [25, 50],
        popupAnchor: [0, -50]
      });

      const marker = L.marker([lat, lng], { icon: simiIcon })
        .addTo(this.map)
        .bindPopup(result.direccion);

      this.markersArray.push(marker);
    });

    // Centrar el mapa en la PRIMER sucursal
    this.map.setView([
      Number(results[0].latitud),
      Number(results[0].longitud)
    ], 14);

  } else {
    this.infoConsultorio = null;
    this.dont = true;
  }
}






}
